import React from 'react'
import Img from 'src/components/shared/Img'

const ReviewedBy = ({ author, reviewedBy }) => {
  if (!author && !reviewedBy) {
    return null
  }

  return (
    <div className={` mt-5 w-full`}>
      <div className="mx-auto max-w-6xl px-4 py-8">
        <h2 className="mb-6 text-2xl font-semibold">Author Information</h2>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Written by */}
          {author && (
            <div className="space-y-4 rounded-lg bg-blue-135 p-6">
              {/* Row 1: Avatar + Info */}
              <div className="flex items-center space-x-4">
                <Img
                  src={author.image}
                  alt={author.fullName}
                  width={64}
                  height={64}
                  layout="intrinsic"
                  className="size-16"
                  imgClassName="h-16 w-16 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm text-neutral-300">Written by</p>
                  <h3 className="text-sm font-medium">{author.fullName}</h3>
                </div>
              </div>
              {/* Row 2: Description */}
              <p className="text-12">{author.description}</p>
            </div>
          )}

          {/* Reviewed by */}
          {reviewedBy && (
            <div className="space-y-4 rounded-lg bg-blue-135 p-6">
              {/* Row 1: Avatar + Info */}
              <div className="flex items-center space-x-4">
                <Img
                  src={reviewedBy.image}
                  alt={reviewedBy.fullName}
                  width={64}
                  height={64}
                  layout="intrinsic"
                  className="size-16"
                  imgClassName="h-16 w-16 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm text-neutral-300">Reviewed by</p>
                  <h3 className="text-sm font-medium">{reviewedBy.fullName}</h3>
                </div>
              </div>
              {/* Row 2: Description */}
              <p className="text-12">{reviewedBy.description}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default React.memo(ReviewedBy)
